<template>
  <div class=" myworks">
    <div class="row" v-if="worksList.length">
      <div class="workBox col col-sm-6 col-md-4" v-for="(item, index) in worksList" :key="index">
        <div class="team_member" :class="device=='mobile'?'mobileStyle':''" @click="goToSeeItem(item)">
          <div class="entry" @click="goWorksDetail(item.id)">
            <img class="img-responsive" :src="item.type == 'Python'? pythonCover : item.cover" alt />
          </div>
          <div class="lawyer">
            <div class="lawyerInfo">
              <h3>{{ item.name }}</h3>
              <div class="lawyer-details">
                <div class="user-panel">
                  <ul class="user-eyes">
                    <li class="likes">
                      <span class="like"></span>
                      {{item.likeNum? item.likeNum : 0}}
                    </li>
                    <li class="eyes">
                      <i class="el-icon-view"></i>
                      {{item.visNum}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <el-button v-if="publish == '已发布'" :type="item.match&&item.match.id?'info':'success'" size="mini" @click="item.match&&item.match.id?'':showSignUpDialog(item,index)">{{item.match&&item.match.id?'已参赛':'报名参赛'}}</el-button>
            <el-button v-if="publish != '收藏夹'" type="primary" size="mini" @click="editWorks(item)">编辑</el-button>
            <el-button v-if="publish != '收藏夹'" type="danger" size="mini" @click="deleteWorks(item.id)">删除</el-button>
          </div>
        </div>
      </div>
    </div>
    <span v-else class="default">
      <img src="@/assets/icon/notdata.png" alt />
      暂时没有作品
    </span>
    <el-pagination
      v-if="totalPages > 1"
      background
      :page-size="pageSize"
      :current-page="pageNumber"
      @current-change="handleCurrentChange"
      :page-count="totalPages"
      layout="total, prev, pager, next"
      :total="totalElements"
    ></el-pagination>
    <!-- 报名参赛 弹框 -->
    <defaultDialog title="报名参赛" width="920px" ref="signUpDialog" @close="signUpDialogClose">
      <el-form
        ref="signUpForm"
        :model="signUpFormData"
        :rules="signUpFormDataRules"
        label-width="100px"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="赛事：" prop="matchId">
              <defaultSelect
                :dataList="matchListData"
                v-model="signUpFormData.matchId"
                placeholder="选择赛事"
                @change="matchChange"
                :propKey="defaultProps"
                className="width160"
                size="small"
              />
            </el-form-item>
            <el-form-item label="赛项：" prop="matchItemId">
              <defaultSelect
                :dataList="matchItemListData"
                v-model="signUpFormData.matchItemId"
                placeholder="选择赛项："
                @change="matchItemChange"
                :propKey="defaultProps"
                className="width160"
                size="small"
              />
            </el-form-item>
            <el-form-item label="组别：" prop="matchItemGroupId">
              <defaultSelect
                :dataList="matchItemGroupListData"
                v-model="signUpFormData.matchItemGroupId"
                placeholder="选择组别"
                :propKey="defaultProps"
                className="width160"
                size="small"
              />
            </el-form-item>
            <el-form-item label="学校：" prop="school">
              <el-input class="width160" v-model="signUpFormData.school" placeholder="请输入所在学校"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="解说视频：" prop="workVideoUrl">
              <div v-show="signUpFormData.workVideoUrl" class="defaultUploadShowStyle">
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-check"></i>
                </label>
                <i class="el-icon-close" @click.prevent="deleteVideo"></i>
                <video
                  class="showImg"
                  width="100%"
                  :src="signUpFormData.workVideoUrl"
                  id="guideVideo"
                  controls="controls"
                ></video>
              </div>
              <clickUpload
                v-show="!signUpFormData.workVideoUrl"
                @change="videoUpload"
                :drag="true"
                :uploadSize="500"
                ref="videoUploader"
                accept=".mp4, .m3u8, .rmvb, .avi, .swf, .3gp, .mkv, .flv"
                :clearUploadedFile="true"
                :uploadPath="`/upload`"
                noticeText="只能上传mp4/m3u8/rmvb/avi/avi/swf/3gp/mkv/flv文件，且不超过500MB"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="图片：" prop="workPictureList">
          <CardUpload @change="changeImg"></CardUpload>
        </el-form-item>
        <el-form-item label="说明文档：" prop="documentUrls">
          <clickUpload
            @change="docsUpload"
            @removed="removeDoc"
            :limit="3"
            listType="text"
            :drag="true"
            :uploadSize="50"
            ref="docUploader"
            accept=".doc, .docx, .pdf, .ppt, .pptx"
            :uploadPath="`/uploadCourseware`"
            noticeText="只能上传doc/docx/pdf/ppt/pptx文件，且不超过50MB"
          />
        </el-form-item>
        <el-form-item align="center" label-width="0">
          <el-button @click="$refs.signUpDialog.visible = false">取 消</el-button>
          <loadingBtn @click="signUp" btnText="报 名" size="small" />
        </el-form-item>
      </el-form>
    </defaultDialog>
  </div>
</template>
<script>
import Loading from "@/components/loading";
import communityApi from "@/request/api/community";
import defaultDialog from "@/components/dialog/dialog";
import defaultSelect from "@/components/filter/defaultSelect";
import matchApi from "@/request/api/match.js";
import fileApi from "@/request/api/file.js";
import clickUpload from "@/components/upload/clickUpload";
import loadingBtn from "@/components/btns/loadingBtn";
import CardUpload from '@/components/upload/cardUpload';
import {mapGetters} from 'vuex'

export default {
  components: {
    Loading,
    defaultDialog,
    defaultSelect,
    clickUpload,
    loadingBtn,
    CardUpload
  },
  //接收父组件传递数据
  props: {
    publish: {
      type: String
    },
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['device','studentId']),
  },
  data() {
    return {
      worksList: [], //作品列表
      totalPages: 0, //总页数
      totalElements: 0, //总条数,
      pageNumber: 1, //当前请求页
      pageSize: 6, //每页显示条数,
      pythonCover: require("@/assets/python.png"),
      loadingHide: false,
      worksListState: false,
      signUpFormData: {
        id: "",
        matchId: "",
        matchItemId: "",
        matchItemGroupId: "",
        school: "",
        workVideoUrl: "",
        workPictureList: [],
        documentUrls:[]
      },
      signUpFormDataRules: {
        matchId:[
          { required: true, message: "请选择赛事", trigger: "change" }
        ],
        matchItemId:[
          { required: true, message: "请选择赛项", trigger: "change" }
        ],
        matchItemGroupId:[
          { required: true, message: "请选择组别", trigger: "change" }
        ],
        school: [
          { required: true, message: "请输所在学校名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "change" }
        ],
        workVideoUrl:[
          { required: true, message: "请上传解说视频", trigger: "change" },
        ],
        workPictureList:[
          { required: true, message: "请上传作品相关图片", trigger: "change" },
        ],
        documentUrls:[
          { required: true, message: "请上传作品说明文档", trigger: "change" },
        ],
      },
      matchListData: [],
      defaultProps: {
        key: "id",
        value: "id",
        label: "name"
      },
      matchItemListData: [],
      matchItemGroupListData: [],
      signUpItemIndex:null
    };
  },
  watch: {
    type() {
      if(this.publish=='收藏夹'){
        this.favoritesList()
      }else{
        this.getPageInfo();
      }
    },
    worksListState() {
      if (this.worksListState) {
        this.loadingHide = true;
      }
    }
  },
  created() {
    if(this.publish=='收藏夹'){
      this.favoritesList()
    }else{
      this.getPageInfo();
    }
  },
  methods: {
    // 收藏夹
    favoritesList(){
      let id = "";
      if(this.$route.query && this.$route.query.id) {
        id = this.$route.query.id;
      } else if(this.studentId) {
        id = this.studentId;
      }
      let params = {
        "name": "",
        "authorId": id,
        "pageNumber": this.pageNumber,
        "pageSize": this.pageSize,
        "sortDirection": 1,
        "sortName": "createDate",
      };
      communityApi.favoritesList(params, res => {
          if(res.succeed) {
              this.worksList = res.data.content;
              this.totalPages = res.data.totalPages ? res.data.totalPages : 0;
              this.totalElements = res.data.totalElements
                ? res.data.totalElements
                : 0;
          }
          this.worksListState = true;
      });
    },
    //获取页面信息
    getPageInfo() {
      let id = "";
      if(this.$route.query && this.$route.query.id) {
        id = this.$route.query.id;
      } else if(this.studentId) {
        id = this.studentId;
      }
      if(id) {
        let params = {
          authorId: id,
          name: "",
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          sortDirection: 1,
          sortName: "createDate",
          status: this.publish,
          type: this.type
        };
        communityApi.myWorksList(params, res => {
          if (res.succeed) {
            this.worksList = res.data.content;
            this.totalPages = res.data.totalPages ? res.data.totalPages : 0;
            this.totalElements = res.data.totalElements
              ? res.data.totalElements
              : 0;
          }
          this.worksListState = true;
        });
      }
    },
    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      if(this.publish=='收藏夹'){
        this.favoritesList()
      }else{
        this.getPageInfo();
      }
    },
    //点击卡片
    goWorksDetail(id) {
      if (this.publish == "已发布") {
        this.$router.push("/workcontent/" + id);
      }
    },
    //编辑作品
    editWorks(item) {
      if (item.type == "Python") {
        this.$router.push({ name: "py", query: { id: item.id } });
      } else if (item.id) {
        this.$router.push({ name: "sh", query: { id: item.id } });
      }
    },
    //删除作品
    deleteWorks(id) {
      if (id) {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            communityApi.deleteWorks(id, res => {
              if (res.succeed) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                for (let i = 0; i < this.worksList.length; i++) {
                  if (this.worksList[i].id == id) {
                    this.worksList.splice(i, 1);
                  }
                }
              } else {
              }
            });
          })
          .catch(() => {});
      }
    },
    async showSignUpDialog(item,index) {
      this.signUpItemIndex=index
      this.signUpFormData.id = item.id;
      await this.matchSelectList();
      this.$refs.signUpDialog.visible = true;
    },
    signUpDialogClose() {
        this.$refs.signUpForm.resetFields();
        this.signUpFormData={
            id: "",
            matchId: "",
            matchItemId: "",
            matchItemGroupId: "",
            school: "",
            workVideoUrl: "",
            workPictureList: [],
            documentUrls:[]
        }
        this.signUpItemIndex=null
    },
    matchSelectList() {
      return new Promise(resolve => {
        matchApi.matchSelectList(res => {
          if (res.succeed) {
            this.matchListData = res.data;
          }
          resolve();
        });
      });
    },
    matchChange(item) {
      this.matchItemSelectList(item);
      this.signUpFormData.matchItemId = "";
      this.signUpFormData.matchItemGroupId = "";
      this.matchItemGroupListData = [];
    },
    matchItemChange(item) {
      this.matchItemGroupSelectList(item);
      this.signUpFormData.matchItemGroupId = "";
    },
    videoUpload(url) {
      this.signUpFormData.workVideoUrl = url;
      this.$refs.signUpForm.validateField('workVideoUrl')
    },
    deleteVideo() {
      this.$confirm("此操作将删除您上传的视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          fileApi.deleteFile(this.signUpFormData.workVideoUrl, res => {
            if (res.succeed) {
              this.signUpFormData.workVideoUrl = "";
            }
          });
        })
        .catch(() => {
          console.log("取消操作");
        });
    },
    matchItemSelectList(id) {
      return new Promise(resolve => {
        matchApi.matchItemSelectList(id, res => {
          if (res.succeed) {
            this.matchItemListData = res.data;
          }
          resolve();
        });
      });
    },
    matchItemGroupSelectList(id) {
      return new Promise(resolve => {
        matchApi.matchItemGroupSelectList(id, res => {
          if (res.succeed) {
            this.matchItemGroupListData = res.data;
          }
          resolve();
        });
      });
    },
    signUp() {
      this.$refs.signUpForm.validate(valid => {
        if (valid) {
          this.$store.dispatch("loading/startLoading");
          communityApi.applyWorks(this.signUpFormData,res=>{
              if(res.succeed){
                  this.$refs.signUpDialog.visible = false
                  this.$set(this.worksList[this.signUpItemIndex],'match',{id:this.signUpFormData.matchId})
                  this.$message({
                    message: '报名参赛成功',
                    type: 'success'
                });
              }
          })
        }
      });
    },
    //作品图片
    changeImg(list) {
      this.signUpFormData.workPictureList = list;
      this.$refs.signUpForm.validateField('workPictureList')
    },
    docsUpload(res){
      this.signUpFormData.documentUrls.push(res.data)
      this.$refs.signUpForm.validateField('documentUrls')
    },
    removeDoc(file){
      fileApi.deleteCourseware(file.response.data,res=>{
        if(res.succeed){
          let index=this.signUpFormData.documentUrls.findIndex(item=>{
            return item==file.response.data
          })
          index!=-1&&this.signUpFormData.documentUrls.splice(index,1)
          this.$message({
              message: '删除成功',
              type: 'success'
          });
        }
      })
    },
    goToSeeItem(item){
      if(this.publish == '收藏夹'){
        this.$router.push(`workcontent/${item.id}`)
      }
    }
  }
};
</script>
<style lang="scss">
.myworks {
  padding: 30px 0;
  .team_member.mobileStyle {
    max-width:100%;
    // margin-bottom: 30px;
  }
  .width160{
    width: 180px;
  }
  .user-panel {
    padding: 2px 0;
    overflow: hidden;
  }
  .user-panel li {
    position: relative;
    display: inline-block;
    font-size: 15px;
  }
  .user-eyes {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    margin-bottom: 0;
  }
  .user-eyes li:nth-child(1) {
    margin-right: 10px;
  }
  .user-eyes i {
    margin-right: 5px;
  }
  .user-eyes .like {
    padding: 9px;
    margin-right: 5px;
    background-image: url("../assets/zan.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
  }
  .user-panel.border-top {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }
  .user-headimg {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 4px;
    cursor: pointer;
  }
  .user-panel.border-top span {
    font-size: 13px;
    cursor: pointer;
  }
  .el-pagination {
    display: flex;
    justify-content: center;
    margin: 50px 0;
  }
  .worksNavList,
  .header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
  }
  .worksNavList li {
    padding: 6px 18px;
    font-size: 16px;
    margin-right: 15px;
    color: #888;
    cursor: pointer;
  }
  .worksNavList li.active {
    color: #000;
    /* background: #FFE200; */
    border-radius: 30px;
  }
  .works-search {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }
  .default {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    color: #8a8a8a;
    font-size: 15px;
  }
  .default img {
    width: 80px;
  }
  .el-pagination {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
  @media (min-width: 1020px) and (max-width: 1200px) {
    .workBox {
        width: 50%;;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/myworks.vue